function safeString(v) {
  return typeof v === "string" ? v : v == null ? "" : String(v);
}

export function mergeAttachmentsById(current, incoming) {
  const merged = [];
  const indexById = new Map();

  (Array.isArray(current) ? current : []).forEach((attachment) => {
    const id = safeString(attachment?.id).trim();
    if (id) indexById.set(id, merged.length);
    merged.push(attachment);
  });

  (Array.isArray(incoming) ? incoming : []).forEach((attachment) => {
    const id = safeString(attachment?.id).trim();
    if (!id) {
      merged.push(attachment);
      return;
    }

    if (indexById.has(id)) {
      merged[indexById.get(id)] = {
        ...(merged[indexById.get(id)] || {}),
        ...(attachment || {}),
      };
      return;
    }

    indexById.set(id, merged.length);
    merged.push(attachment);
  });

  return merged;
}
